'use client';
import useSWR from 'swr';
import { fetchChatNovelScriptForClient } from '~/app/(default-layout)/s/[storyId]/_request/fetch-chat-novel-script';
import { Loading } from '~/app/_components/loading';
import type { StoryOverview } from '~/common/types/story-overview';
import { ChatScriptRender } from './chat-script-render';

type Props = {
  story: StoryOverview;
  canShowGoogleAd: boolean;
  nextStoryId?: string;
  nextStorySeriesIndex?: number;
  nextStoryIsVipOnly?: boolean;
};

const KEY = 'fetch-chat-novel-script-for-client';

export const ChatScriptRenderForClient = ({
  story,
  canShowGoogleAd,
  nextStoryId,
  nextStorySeriesIndex,
  nextStoryIsVipOnly,
}: Props) => {
  // NOTE: Client-side rendering is only available in VIP state, so specify isTrial as false.
  const { data, isLoading } = useSWR([KEY, story.id], () =>
    fetchChatNovelScriptForClient({ storyId: story.id, isTrial: false })
  );

  if (isLoading) return <Loading />;

  if (!data) return <></>;

  return (
    <ChatScriptRender
      story={story}
      chatNovelScript={data.chatNovelScript}
      canShowGoogleAd={canShowGoogleAd}
      nextStoryId={nextStoryId}
      nextStorySeriesIndex={nextStorySeriesIndex}
      nextStoryIsVipOnly={nextStoryIsVipOnly}
    />
  );
};
